import React from "react";
//import FormNavbar from "../Components/FormNavbar/FormNavbar";
import ResetPassword from "../Components/ResetPassword/ResetPassword";
import UserProfileHeader from "../Components/UserProfile/UserProfileHeader/UserProfileHeader";
//import VerticalNavBar from "../Components/VerticalNavBar/VerticalNavBar";

const ResetPasswordPage = () => {
  return (
    <div>
      <UserProfileHeader />
      <ResetPassword />
    </div>
  );
};

export default ResetPasswordPage;
